import { Injectable, NgZone, ApplicationRef, Optional } from '@angular/core';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Shell } from './shell';
import { Head } from './head';
import { Redirection } from './redirection';

@Injectable()
export class PageService {
    constructor(
        public zone : NgZone,
        @Optional() public stateTransfer : TransferState,
        public appRef : ApplicationRef,
        public title : Title,
        public meta : Meta,
        public router : Router,
        public head : Head,
        public redirection : Redirection,
        public shell : Shell
    ) {
        //if (this.stateTransfer) {
        //  appRef.isStable.subscribe(() => this.stateTransfer.inject());
        //}
    }
}